/* __next_internal_client_entry_do_not_use__ AccessibleStarsDescription auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Row } from "@faire/web--source/slate/Layout";
import React from "react";
export var AccessibleStarsDescription = function(param) {
    var rating = param.rating, children = param.children, dataTestId = param["data-test-id"];
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsx(Row, {
        "data-test-id": dataTestId,
        "aria-label": strictLocalize({
            id: "s2zeci",
            defaultMessage: [
                {
                    type: 6,
                    value: "starsNumber",
                    options: {
                        one: {
                            value: [
                                {
                                    type: 7
                                },
                                {
                                    type: 0,
                                    value: " of 5 stars"
                                }
                            ]
                        },
                        other: {
                            value: [
                                {
                                    type: 7
                                },
                                {
                                    type: 0,
                                    value: " of 5 stars"
                                }
                            ]
                        }
                    },
                    offset: 0,
                    pluralType: "cardinal"
                }
            ]
        }, {
            starsNumber: rating
        }),
        role: "img",
        children: /*#__PURE__*/ _jsx("div", {
            "aria-hidden": "true",
            children: children
        })
    });
};
